import React from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row, Col, Table } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";
import LeftAdministration from "./LeftAdministration";

function Main() {

  const teachers = [
    {
      heading : "Director"
    },
    {
        name: "Prof. K.N. Satyanarayana",
        namelink:"https://iittp.ac.in/director",
        position1: "Director",
        position2: "",
        phoneno:"0877-250 3003",
        email: "director@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/director.jpg"
    },
    {
      heading : "Deans"
    },
    {
        name: "Prof. Muthukumar Palanisamy",
        namelink: "#",
        position1: "Dean",
        position2: "Faculty Affairs",        
        phoneno: "0877 250 XXXX",
        email: "dean_fa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg"
    }, 
    {
        name: "Prof. Sasidhar Gumma",
        namelink: "#",
        position1: "Dean",
        position2: "International and Alumni Affairs",
        phoneno: "0877 250 3671",
        email: "dean_ia@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/SG.jpg"
    },
    {
        name: "Dr. Rama Krishna Sai Gorthi",
        namelink: "#",
        position1: "Dean",
        position2: "Academic Affairs",
        phoneno: "0877 250 3260",
        email: "dean_aa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/SubramanyamSai.JPG"
    },
    {
        name: "Prof. A. Murali Krishna",
        namelink: "#",
        position1: "Dean",
        position2: "Planning and Infrastructure",
        phoneno: "0877 250 3609",
        email: " dean_pi@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/AMK-NEW.jpg"
    },
    {
        name: "Prof. KSMS Raghava Rao",
        namelink: "#",
        position1: "Dean",
        position2: "Administration & Finance",
        phoneno: "0877 250",
        email: "dean_af@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/raghavarao.png"
    },
    {
        name: "Dr. N N Murty",
        namelink: "#",
        position1: "Dean",
        position2: "Student Affairs  ",
        phoneno: "0877 250 3256 ",
        email: "dean_sa@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/nnmurthy.jpg"
    },
    {
        name: "Dr. Anil Kumar Emadabathuni",
        namelink: "#",
        position1: "Dean ",
        position2: "Sponsored Research and Consultancy",
        phoneno: "0877 250 3405",
        email: "dean_src@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/anil.jpg"
    },
    {
      heading : "Registrar In-charge"
    },
    {
        name: "Prof. Venkata Ramana Badarla",
        namelink: "#",
        // namelink: "https://iittp.ac.in/registrar",
        position1: "Registrar In-charge",
        position2: "",
        phoneno: "0877 250 3040",
        email: "registrar@iittp.ac.in",
        image: "https://files.iittp.ac.in/images/demo/iit/ramana.jpg"
    },
    {
      heading : "Head of the Departments"
    },
    {
      name: "Prof. Thamida Sunil Kumar",
      namelink: "#",
      position1: "Chemical Engineering ",
      position2: "",
      phoneno: "9492079213",
      email: "hod_ch@iittp.ac.in",
      image: "https://files.iittp.ac.in/images/demo/iit/Thamida_sunil_kumar_2019.jpg",
  },
  {
    name: "Prof. Gouriprasanna Roy",
    namelink: "#",
    position1: "Chemistry ",
    position2: "",
    phoneno: "0877 250 XXXX",
    email: "hod_chemistry@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/Gouriprasanna Roy.jpg",
  },
  {
    name: "Prof. Suresh Jain",
    namelink: "#",
    position1: "Civil & Environmental Engineering ",
    position2: "",
    phoneno: "0877 250 3166",
    email: "hod_ce@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/SureshPP.JPG",
  },
  {
    name: "Dr. Sridhar Chimalakonda",
    namelink: "#",
    position1: "Computer Science and Engineering",
    position2: "",
    phoneno: "0877 250 3211",
    email: "hod_cse@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg",
  },

    {
      name: "Dr. K P Naveen",
      namelink: "#",
      position1: "Electrical Engineering",
      position2: "",
      phoneno: "0877 250 3255",
      email: "hod_ee@iittp.ac.in",
      image: "https://files.iittp.ac.in/images/demo/iit/naveenkp.jpg",
    },

  {
    name: "Dr. Prabha Shankar Dwivedi",
    namelink: "#",
    position1: "Humanities and Social Sciences",
    position2: "",
    phoneno: "0877 250 3307",
    email: "hod_hss@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/Prabha.jpg",
  },
  {
    name: "Dr. Ishapathik Das",
    namelink: "#",
    position1: "Mathematics and Statistics",
    position2: "",
    phoneno: "0877 250 3358",
    email: "hod_ma@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/ishap.jpg",
  },
  {
    name: "Prof. Mamilla Ravi Sankar",
    namelink: "#",
    position1: "Mechanical Engineering",
    position2: "",
    phoneno: "0877 250 3410",
    email: "hod_me@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/EVMRS.JPG",
  },
  {
    name: "Dr. Rudra Sekhar Manna",
    namelink: "#",
    position1: "Physics",
    position2: "",
    phoneno: "0877 250 3458",
    email: "hod_physics@iittp.ac.in",
    image: "https://files.iittp.ac.in/images/demo/iit/Rudra.jpg",
  },



  ] 

  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Administration" />
      <section className="project-detail">
        <div className="container">
          <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
            <h5><i className="fal fa-graduation-cap" /> Administration</h5>
            <h2>Academic Administration</h2>
          </div>
          <Row>
            <Col md={4} className="c-left ">
                <LeftAdministration activeIndex={1} />
            </Col>
            <Col md={8} className="c-left">
              <Row>
                {teachers.map((teacher, index) => (
                                teacher.heading ? <h2 className="mb-3">{teacher.heading}</h2> :
                                <div key={index} className="col-xl-6 col-md-8">
                                    <div className="single-team mb-40">
                                        <div className="team-thumb">
                                            <div className="brd">
                                                <Link to="/acad-admin">
                                                    <img src={teacher.image} alt="img" />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="team-info">
                                            <h4>
                                                <Link to={teacher.namelink}>{teacher.name}</Link>
                                            </h4>
                                            <div className="text-dark">
                                            <p >{teacher.position1}</p>
                                                <p className="text-dark">{teacher.position2}</p>
                                                <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{teacher.phoneno}</p>
                                                {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.email} target="_blank" className="btn btn-primary">{teacher.email}</Link></p> */}
                                                <p className="text-dark"><i className="fal fa-envelope  me-2"></i>{teacher.email}</p>
                                            </div>
                                            <div className="team-social">
                                                {/* <ul>
                                                    {teacher.social.map((platform, index) => (
                                                        <li key={index}>
                                                            <Link to={platform.link}>
                                                                {platform.platform === 'facebook' && <i className="fab fa-facebook-f" />}
                                                                {platform.platform === 'instagram' && <i className="fab fa-instagram" />}
                                                                {platform.platform === 'twitter' && <i className="fab fa-twitter" />}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                </Row>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Main;
